/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 16oTSa7DQBPEWCKQEY9DXA

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/projectModule

const data = {
  base: `${"plasmic_tokens_16oTSa7DQBPEWCKQEY9DXA"} ${"plasmic_tokens_ohDidvG9XsCeFumugENU3J"}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
